export const PINK = {
  DARKEST: '#771C6E',
  DARKER: '#AF50A0',
  DARK: '#DA7ECB',
  DEFAULT: '#F1CEEC',
  LIGHT: '#F0E0EF',
  LIGHTER: '#F3E8F2',
  LIGHTEST: '#F9F2F8',
} as const;
